import 'stylesheets/styles.scss';

import { Navigation } from './classes/Navigation';
import { FooterChildren } from './classes/FooterChildren';
import { PageWorker } from './classes/PageWorker';
import { Loader } from './classes/Loader';
import { isMobileDevice } from './utils/isMobile';
// import { onBackOnline } from './content/mains/minilab/utils';

async function setHeader() {
	const { navigationContent } = await import('./content/navigationContent');
	const nav = new Navigation(navigationContent);
	const header = document.querySelector('header');
	const navContent = await nav.getNavigation();
	header.insertAdjacentElement('afterbegin', navContent);
}

async function setFooter() {
	const { footerContent } = await import('./content/footerContent');
	const footerChildren = new FooterChildren(footerContent);
	const footer = document.querySelector('footer');
	const footerContentElement = await footerChildren.getFooterContent();
	footer.insertAdjacentElement('afterbegin', footerContentElement);
}

async function setMain() {
	let mainChild;
	let loader;

	loader = new Loader();
	loader.insert().then((loader) => loader.show());

	if (mainChild && mainChild.name === '_404_') mainChild.clearTimer();

	mainChild = await PageWorker.getChildByHash(location.pathname);
	await mainChild.setMain();

	// onBackOnline();

	if (mainChild.name === '_404_') mainChild.goHomeInSeconds(5, setMain);

	setTimeout(() => loader.hide(), 250);
}

const setEvents = () => {
	window.openInNewTab = false;

	window.addEventListener('keydown', ({ key }) => {
		if (['Meta', 'Control'].includes(key)) openInNewTab = true;
	});

	window.addEventListener('keyup', ({ key }) => {
		if (['Meta', 'Control'].includes(key)) openInNewTab = false;
	});

	window.addEventListener('popstate', () => setMain(), { passive: true });

	document.addEventListener(
		'click',
		(event) => {
			const url = event.target.getAttribute('href');
			if (
				event.target.matches('a') &&
				url &&
				url.length &&
				url.indexOf('/') === 0 &&
				!openInNewTab
			) {
				event.preventDefault();
				history.pushState({}, '', url);
				setMain();
			}
		},
		{ passive: false }
	);

	if (isMobileDevice()) {
		let lastScrollY = window.scrollY;
		const header = document.querySelector('header');
		const hideHeaderClass = 'hide-header';
		document.addEventListener(
			'scroll',
			() => {
				const bottomScroll = window.scrollY > lastScrollY;
				const method =
					bottomScroll && window.scrollY > innerHeight * 0.1 ? 'add' : 'remove';
				header.classList[method](hideHeaderClass);
				lastScrollY = window.scrollY;
			},
			{ passive: true }
		);
	}
};

const launch = async () => {
	setHeader();
	await setMain();
	setFooter();
};

launch();
setEvents();

if (
	navigator.userAgent.indexOf('iPhone') > -1 ||
	navigator.userAgent.indexOf('iPad') > -1
) {
	document.body.classList.add('iOS_Device');
}

if (
	!navigator.userAgent.includes('OPR') &&
	!navigator.userAgent.includes('Edg') &&
	!navigator.userAgent.includes('Chrome') &&
	!navigator.userAgent.includes('Firefox')
) {
	document.body.classList.add('safari');
}
